export default __webpack_public_path__ + "static/media/p1-slice3.2b3d6c56.png";